import APIKeyPageContent from '@/components/APIKeyPage'

export default function APIKeyPage() {
  return <APIKeyPageContent />
}

